<template>
  <div data-sticky-container class="h-100">
    <BuildingCard class="mb-md-5" style="max-width: 600px">
      <ClientDetails class="mx-2 pb-3" />
    </BuildingCard>

    <base-card
      v-if="$vuetify.breakpoint.mdAndUp"
      class="sticky mb-5 d-flex flex-column justify-end"
      :loading="$store.state.loading.includes('stepper')"
      max-height="96vh"
    >
      <v-sheet style="overflow-y: auto" class="border-bottom" v-show="showEstimateItems">
        <EstimateItems class="mx-2 pb-3" all />
      </v-sheet>

      <PricingTotals class="mx-2 pb-3" />
    </base-card>
  </div>
</template>

<script>
var Sticky = require("sticky-js");

import ClientDetails from "../client/ClientDetails";
import PricingTotals from "../totals/PricingTotals";
import EstimateItems from "../totals/EstimateItems";
import BuildingCard from "../object/BuildingCard";
export default {
  components: {
    BuildingCard,
    EstimateItems,
    PricingTotals,
    ClientDetails,
  },
  mounted() {
    new Sticky(".sticky", { stickyWrap: true, marginTop: 16, dataStickyFor: 959 /* mdAndUp */ });
  },
  computed: {
    showEstimateItems() {
      for (const element of this.$store.state.pricing.items) {
        if (element.items.length) return true;
      }

      return false;
    },
  },
};
</script>

<style>
</style>
